module.exports = __webpack_public_path__ + "static/media/stop-19.eb87a2c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-19.svg
// module id = 1386
// module chunks = 0